import { useLocation } from "react-router-dom";
import { Logo } from "./Logo";

const NAV = [
  { label: "Home", href: "#top" },
  { label: "Services", href: "#services" },
  { label: "About", href: "#why" },
  { label: "AI", href: "#ai" },
  { label: "Contact", href: "#contact" },
];

const SERVICES_LINKS = [
  { label: "Enterprise Software", href: "/services/enterprise-software" },
  { label: "SaaS", href: "/services/enterprise-saas-software" },
  { label: "Web", href: "/services/web-application-development" },
  { label: "Mobile", href: "/services/mobile-app-development" },
  { label: "AI", href: "/services/generative-ai" },
  { label: "Cloud & DevOps", href: "/services/aws-azure-gcp" },
  { label: "Support", href: "/services/application-support-maintenance" },
];

export const Footer = () => {
  const { pathname } = useLocation();
  const linkHref = (h) => (pathname === "/" ? h : "/" + h);
  return (
  <footer className="relative border-t hairline bg-card/40" data-testid="footer">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-16">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo />
          <p className="mt-4 max-w-xs text-sm text-muted-foreground leading-relaxed">
            Software Engineering &amp; Technology. Enterprise software, SaaS, mobile, AI and
            cloud — engineered end-to-end.
          </p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">Navigate</p>
          <ul className="mt-4 space-y-2.5">
            {NAV.map((l) => (
              <li key={l.label}>
                <a href={linkHref(l.href)} className="text-sm text-foreground/75 transition-colors duration-200 hover:text-primary" data-testid={`footer-nav-${l.label.toLowerCase()}`}>
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">Services</p>
          <ul className="mt-4 space-y-2.5">
            {SERVICES_LINKS.map((l) => (
              <li key={l.label}>
                <a href={l.href} className="text-sm text-foreground/75 transition-colors duration-200 hover:text-primary" data-testid={`footer-service-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t hairline pt-8 sm:flex-row sm:items-center">
        <p className="text-xs text-muted-foreground">© Farmint. All rights reserved.</p>
        <div className="flex items-center gap-5 text-xs text-muted-foreground">
          <a href="mailto:hello@farmint.in" className="transition-colors hover:text-primary" data-testid="footer-email">hello@farmint.in</a>
          <a href="https://farmint.in" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-primary" data-testid="footer-website">farmint.in</a>
        </div>
      </div>
    </div>
  </footer>
  );
};
